import {getColumnsByNames} from './all-top10-columns-config';

export const topBlockedDomains = getColumnsByNames([
    {name: 'domain', width: '40%'},
    {name: 'category', width: '25%'},
    {name: 'count', width: '35%'}
]);